import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';
import { cn } from '@/lib/cn';

// Status badges use a 15 % tint of the status colour with the AA-safe "-fg" text token (§11.5).
const badgeVariants = cva('inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium', {
  variants: {
    variant: {
      neutral: 'bg-muted text-muted-foreground',
      primary: 'bg-primary/15 text-link',
      success: 'bg-success/15 text-success-fg',
      warning: 'bg-warning/15 text-warning-fg',
      danger: 'bg-danger/15 text-danger-fg',
      info: 'bg-info/15 text-info-fg',
      // original outlined tag (Archived, Deactivated, role, +N day)
      outline: 'rounded border border-border bg-transparent px-2 py-0.5 text-xs font-normal text-muted-foreground',
    },
  },
  defaultVariants: { variant: 'outline' },
});

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps): JSX.Element {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge };
